export default "__VITE_ASSET__Dy4sEeeW__"